import React, { useEffect } from 'react';
import NewProperties from '../components/home/NewProperties';

export default function MhadaProperties() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return <NewProperties variant="page" />;
}
